module.exports = __webpack_public_path__ + "static/haregon_lake_boat-42e60e90e5985a20fc7b2c094eeca582.webp";